<form [formGroup]="userLobbySettings" (ngSubmit)="submitUserLobbySettings()">
  <div class="row">
    <div class="col-md-4 checkbox">
      <label>
        <input id="showUserInLobby" formControlName="showUserInLobby" class="cc-filter-checkbox" type="checkbox"
          kendoCheckBox />
        {{'_User_Lobby_Settings_Show_In_Lobby_Label_Text_' | translate }}
      </label>
    </div>
    <div class="col-md-4 checkbox">
      <label>
        <input id="showInKiosk" formControlName="showInKiosk" class="cc-filter-checkbox" type="checkbox"
          kendoCheckBox />
        {{'_General_Show_In_Kiosk_Text_' | translate }}
      </label>
    </div>
    <div class="col-md-4 checkbox d-flex align-items-center">
      <label>
        <input id="showAsSupervisor" formControlName="showAsSupervisor" class="cc-filter-checkbox" type="checkbox"
          kendoCheckBox />
        {{'_User_Lobby_Settings_Show_As_Supervisor_Label_Text_' | translate }}
      </label>
    </div>
    <div class="col-md-4">
      <label for="supervisor">{{'_General_My_Supervisor_Text_' | translate }}</label>
      <select class="cc-select-dropdown form-control" id="userGroup" formControlName="supervisor" placeholder="Select">
        <option value="">{{'_General_Select_Text_' | translate }}</option>
        <option *ngFor="let user of supervisorList" [ngValue]="user">
          {{user.fullName}}
        </option>
      </select>
    </div>
    <div class="col-md-4">
       
        <label for="defaultMerge">{{'_General_Default_Lobby_Tab_Text_' | translate }}</label>
        <select  class="cc-select-dropdown form-control" id="defaultMerge" formControlName="defaultLobbyTab" [(ngModel)]="ngDefaultSelected">
          <option  *ngFor="let option of defaultLobbyTabsMerges"  [ngValue]="option.id">{{option.value | translate}}</option>
        </select>

    </div>
    <div *ngIf="globalUserImpersonationEnabled" class="col-md-4 checkbox d-flex align-items-center">
      <label>
        <input id="enableUserImpersonation" formControlName="enableUserImpersonation" class="cc-filter-checkbox" type="checkbox"
          kendoCheckBox />
          {{'_User_Lobby_Settings_Enable_User_Impersonation_Text_' | translate }}
      </label>
    </div>
    <div *ngIf="globalUserImpersonationEnabled" class="col-md-4 checkbox d-flex align-items-center">
      <label>
        <input id="showUserForImpersonation" formControlName="showUserForImpersonation" class="cc-filter-checkbox" type="checkbox"
          kendoCheckBox />
          {{'_User_Lobby_Settings_Show_User_Impersonation_Text_' | translate }}
      </label>
    </div>
  </div>
  <!-- Button Panel -->
  <div class="cc-btn-panel">
    <button type="button" (click)="closeClicked()" class="btn btn-secondary">{{'_General_Button_Close_Text_' | translate }}</button>
    <button type="submit" class="btn btn-primary"
      [disabled]="!userLobbySettings.valid || !userLobbySettings.dirty">{{'_General_Button_Save_Text_' | translate }}</button>
  </div>
</form>
